<template>
<span>
    <div class="header-tool__overlay" v-if="lockRoomForm" @click="lockRoomForm=false"></div>
    <el-popover
        class="share"
        :visible-arrow="false"
        placement="bottom-start"
        v-model="lockRoomForm"
    >
        <el-button slot="reference" class="btn" type="text" title="Lock room">
            <IconBase
                :height="24"
                :width="24"
                :fill=" (lockRoomForm || currentRoom.isLocked) ? '#50C6DF': '#E7E6FA'"
                :class="{'lock-room-active': this.currentRoom.isLocked}"
                class="lock-room"
            >
                <IconLock />
            </IconBase>
        </el-button>

        <div v-if="lockRoomForm" width="35%" class="header-tool__popup">
            <div v-if="currentRoom.isLocked">
                <div class="header-tool__header">
                    <h3> Unlock this Room</h3>
                    <div @click="lockRoomForm=false">
                        <IconBase
                            :height="24"
                            :width="24"
                            :view-box="`0 0 24 24`"
                            :fill="'#E7E6FA'"
                        >
                            <IconCross />
                        </IconBase>
                    </div>
                </div>
                <div class="header-tool__body">Are you sure you want to unlock this room?</div>
                <div class="header-tool__footer">
                    <el-button size="small" @click="lockRoomForm=false">Cancel</el-button>
                    <el-button size="small" class="confirm" type="primary" @click="setLockStatus">Confirm</el-button>
                </div>
            </div>
            <div v-else>
                <div class="header-tool__header">
                <h3 class="header-tool__title">Lock this room</h3>
                <div @click="lockRoomForm=false">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
                </div>
                <div class="header-tool__body">Are you sure you want to lock this room?</div>
                <div class="header-tool__footer">
                    <el-button size="small" @click="lockRoomForm=false">Cancel</el-button>
                    <el-button size="small" class="confirm" type="primary" @click="setLockStatus">Confirm</el-button>
                </div>
            </div>
        </div>
    </el-popover>
</span>
</template>

<script>
import IconBase from '../IconBase'
import IconLock from '../icons/IconLock'
import IconCross from '../icons/IconCross'
import {
    mapState
} from 'vuex';
import axios from '../../client';

export default {
    name: "Lock",
    components: {
        IconBase,
        IconLock,
        IconCross
    },

    data: function () {
        return {
            lockRoomForm: false,
        };
    },

    methods: {
        async setLockStatus() {
            this.lockRoomForm = false;
            try {
                await axios.put('/api/rooms/' + this.currentRoom._id, {
                    mainRoom: this.mainRoom.name,
                    isLocked: !this.currentRoom.isLocked,
                    password: ''
                })
            } catch (err) {
                if (err.response.data.message === "TOKEN_EXPIRED") {
                    this.$store.dispatch("user/refreshTokens", this.setLockStatus);
                } else {
                    alert(err)
                }
            }
        }
    },
    computed: {
        ...mapState({
            currentRoom: state => state.rooms.currentRoom,
            mainRoom: state => state.rooms.mainRoom,
            tokens: state => state.user.tokens

        }),
    }
}
</script>

<style scoped>
>>>.header-tool__overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vmax;
    background: #000;
    opacity: 0.5;
    z-index: 15;
}
>>>.header-tool {
    position: relative;
}
>>>.header-tool__popup {
    position: absolute;
    padding: 0 12px;
    z-index: 1;
    background: #2A2A3D;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    min-width: 320px;
    min-height: 177px;
    color: #E7E6FA;
}

>>>.header-tool__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
>>>.header-tool__body {
    text-align: left;
    margin-bottom: 20px;
}
>>>.header-tool__footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
}
>>>button.el-button--default,
>>>button.el-button--default:hover,
>>>button.el-button--default:active {
    height: 36px;
}

>>>button.el-button--primary,
>>>button.el-button--primary:hover,
>>>button.el-button--primary:active {
    height: 36px;
}

>>>input.el-input__inner,
>>>.el-input.is-disabled .el-input__inner {
    background: #393752;
    border-radius: 3px;
    height: 32px;
    border: none;
    color: #E7E6FA;
}

>>>label {
    display: inline-block;
    font-size: 16px;
    line-height: 20px;
    color: #E7E6FA;
    margin-bottom: 6px;
}

@media (max-width: 767px) {
    .share .btn {
        position: relative;
    }

    .share .btn[title]:hover:after{
        content: attr(title);
        display: none;
    }
}

@media (hover: none) {
    .share .btn {
        position: relative;
    }

    .share .btn[title]:hover:after{
        content: attr(title);
        display: none;
    }
}

</style>
